export default "__VITE_ASSET__CVIzce_x__"